<template>
    <CustomHeaderMobile @click="$emit('click')"/>
</template>

<script>
export default {
  name: 'HeaderMobile'
}
</script>



// WEBPACK FOOTER //
// src/front/components/mobile/pages/layout/home/Header.vue